var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5704 7.17334C26.2679 6.08893 25.3813 5.23411 24.2569 4.94212C22.2027 4.40015 13.986 4.40015 13.986 4.40015C13.986 4.40015 5.76958 4.40015 3.71544 4.92157C2.61266 5.21325 1.70439 6.08909 1.4019 7.17334C0.861328 9.15396 0.861328 13.2615 0.861328 13.2615C0.861328 13.2615 0.861328 17.3898 1.4019 19.3497C1.70471 20.434 2.59103 21.2888 3.7156 21.5808C5.79121 22.1229 13.9863 22.1229 13.9863 22.1229C13.9863 22.1229 22.2027 22.1229 24.2569 21.6015C25.3815 21.3097 26.2679 20.4548 26.5708 19.3706C27.1112 17.3898 27.1112 13.2824 27.1112 13.2824C27.1112 13.2824 27.1328 9.15396 26.5704 7.17334ZM11.37 17.0562V9.46682L18.2026 13.2615L11.37 17.0562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.a9a13600097aafb7a5ce17f06c1c6ac7.svg";
export { ForwardRef as ReactComponent };